var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartWaterUsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_5296_9102)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4167 13.918H14.375V30.3851H19.4167V13.918ZM33.1667 18.5013H28.125V30.3851H33.1667V18.5013ZM21.25 23.0846H26.2917V30.3851H21.25V23.0846ZM14.5015 34.0517H33.1667V32.2184H14.5015V34.0517Z",
    fill: "url(#paint1_linear_5296_9102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5296_9102",
    x1: 48,
    y1: 48,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AC693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DFAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5296_9102",
    x1: 23.7708,
    y1: 13.918,
    x2: 23.7708,
    y2: 34.0517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartWaterUsed);
export default __webpack_public_path__ + "static/media/chart-water-used.c47d8d6f4a4f78666c0bf75019296749.svg";
export { ForwardRef as ReactComponent };